/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {SimpleMask as ɵa} from './src/simple-mask';